import React, { useState,useEffect } from "react";
import { useNavigate, Link, useParams, } from "react-router-dom";
import axios from "../api/baseurl";
import { toast} from "react-toastify";
import "./Spinner.css";
import "react-toastify/dist/ReactToastify.css";
import { Modal, Button } from "react-bootstrap";

const AddDoctors = ({ isOpen, onRequestClose, companyId}) => {
  const navigate = useNavigate();
  const url = "/api/createAccount"
        const token = JSON.parse(localStorage.getItem("data")).token;

  const [doctorDetails, setDoctorDetails] = useState(
    {
     username:"",
     role:"ROLE_DOCTOR",
     doctorDetails:{
        doctorName:"",
        phoneNumber:"",
        gender:"",
        dob:"",
        adharNumber:"",
        companyId:companyId,
        email:"",
        address:"",
        pan:"",
        city:"",
        pincode:"",
        state:"",
        sendNotification:false,
        locationId:"",
        doctorProfileImage:{
          image:null,
          imageMeta:"",
        }
     }
      },
  );
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
      e.preventDefault();
      setLoading(true);
      try {
        const emailCheckResponse = await axios.get(`/api/accounts/getByEmail=${doctorDetails.email}`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        if (emailCheckResponse.data) {
          toast.error("Email already exist.");
          setLoading(false);
          return;
        }
      } catch (error) {
        handleError(error);
        setLoading(false);
        return;
      }
      axios
        .post(url, {
          username: doctorDetails.email,
          role:"ROLE_DOCTOR",
          doctorDetails: {
            doctorName:doctorDetails.doctorName,
            phoneNumber:doctorDetails.phoneNumber,
            gender:doctorDetails.gender,
            dob:doctorDetails.dob,
            adharNumber:doctorDetails.adharNumber,
            companyId:companyId,
            email:doctorDetails.email,
            address:doctorDetails.address,
            pan:doctorDetails.pan,
            city:doctorDetails.city,
            pincode:doctorDetails.pincode,
            state:doctorDetails.state,
            sendNotification:doctorDetails.doctorDetails.sendNotification,
            locationId:doctorDetails.locationId,
            doctorProfileImage:doctorDetails.doctorDetails.doctorProfileImage
          }
        }, {
            headers: { Authorization: `Bearer ${token}` }
        })
        .then((res) => {
          setLoading(false);
         
          onRequestClose();
          setDoctorDetails("");
          toast("Doctor account created successfully and Password sent to their email");
        })
        .catch((error) => {
          setLoading(false);
          handleError(error);
          // setDoctorDetails("");
        });
  
  }

  function handleError(error) {
    if (error.response) {
      if (error.response.status === 401) {
        navigate(`/signin`);
        toast.error("Your session has expired. Please login.");
      } else if (error.response.data && error.response.data.message) {
        toast.error(error.response.data.message);
      }  else if (error.response.data && error.response.data.code) {
        toast.error(error.response.data.code);
      }
       else {
        toast.error("An error occurred.");
      }
    } else if (error.message) {
      toast.error(error.message);
    } else {
      toast.error("An error occurred.");
    }
  }

   
  function getBase64FromFile(file) {
    return new Promise((resolve, reject) => {
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function () {
       const [metadata, content] = reader.result.split(",");
       resolve({ metadata, content });};
       reader.onerror = function (error) {
       reject(error);};}); }

       const handleImageChange = async (event) => {
        if (event.target.files && event.target.files[0]) {
            const convertedImage = await getBase64FromFile(event.target.files[0]);
    
            setDoctorDetails((prevState) => ({
                ...prevState,  
                doctorDetails: {
                    ...prevState.doctorDetails,  // Keep all other properties in employeeDetails
                    doctorProfileImage: {
                        imageMeta: convertedImage.metadata,
                        image: convertedImage.content,
                    },
                },
            }));
        }
    };

  function rhandle(e) {
    const { id, value } = e.target;
    setDoctorDetails((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  }

  const [gender, setGender] = useState([]);
  const [locations, setLocations] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = JSON.parse(localStorage.getItem("data")).token;
        const gender = await axios.get(`/api/gender`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setGender(gender.data);

         const loc = await axios.get(`/api/geolocation/companyId=${companyId}`, {
                  headers: { Authorization: `Bearer ${token}` },
                });
                setLocations(loc.data);
      } catch (error) {
        console.error(error);
        toast.error("Failed to fetch designations.");
      }
    };
    fetchData();
  }, []);

  const handleSendNotificationChange = (e) => {
    const { checked } = e.target;
    setDoctorDetails((prevState) => ({
      ...prevState,
      doctorDetails: {
        ...prevState.doctorDetails,
        sendNotification: checked
      }
    }));
  };


  return (
    <Modal show={isOpen} onHide={onRequestClose} centered size="lg">
    <Modal.Header closeButton>
    <Modal.Title>Create Doctor Details</Modal.Title>
    </Modal.Header>
    <Modal.Body>
    {loading && <div className="loading"></div>} 
    <div className="col-xl-10 mx-xl-auto">
          <div className="card card-raised mb-2">
            <div className="card-body p-4 ">
            <form onSubmit={handleSubmit}>
            <div className="d-flex flex-column align-items-center">
              <div className="mb-4">
                {doctorDetails.doctorDetails?.doctorProfileImage.image ? (
                  <img
                  className="img-fluid mb-1"
                  id="image"
                  src={`${doctorDetails.doctorDetails?.doctorProfileImage.imageMeta},${doctorDetails.doctorDetails?.doctorProfileImage.image}`}
                  alt="User Profile"
                  style={{
                    width: "150px",
                    height: "150px",
                    display: "block",
                    background: "#ccc",
                    marginTop: "20px",
                    borderRadius: "50%"
                  }}
                />
              ) : (
                <div
                  className="img-fluid mb-1"
                  id="image"
                  style={{
                    width: "150px",
                    height: "150px",
                    display: "block",
                    background: "#ccc",
                    marginTop: "20px",
                    borderRadius: "50%"
                  }}
                ></div>
              )}
              <input
                className="col-7"
                type="file"
                id="image"
                onChange={(event) => {
                  handleImageChange(event);
                }}
                accept="image/*"
              />
            </div>
            </div>
                <div className="row">
                <div className="col-md-6">
                  <div className="form-floating-sm mb-2">
                    <label htmlFor="doctorName">Name <span style={{color:"red"}}>* </span></label>
                    <input
                      className="form-control"
                      id="doctorName"
                      type="text"
                      placeholder="Name"
                      value={doctorDetails.doctorName}
                      onChange={(e) => rhandle(e)}
                      required
                    />
                   </div>
                  </div>
                
                <div className="col-md-6">
                  <div className="form-floating-sm mb-2">
                    <label htmlFor="email">Email Id <span style={{color:"red"}}>* </span></label>
                    <input
                      className="form-control"
                      id="email"
                      type="email"
                      placeholder="Email"
                      value={doctorDetails.email}
                      onChange={(e) => rhandle(e)}
                      required
                    />
                  </div>
                </div>
                </div>

                <div className="row">
                <div className="col-md-6">
                  <div className="form-floating-sm mb-2">
                    <label htmlFor="contact">Phone Number <span style={{color:"red"}}>* </span></label>
                    <input
                      className="form-control"
                      id="phoneNumber"
                      type="text"
                      placeholder="Phone Number"
                      value={doctorDetails.phoneNumber}
                      onChange={(e) => rhandle(e)}
                      required
                    />
                  </div>
                </div>
          
                <div className="col-md-6">
                <div className="form-floating-sm mb-2">
                    <label htmlFor="gender">
                      Gender <span style={{ color: "red" }}>*</span>
                    </label>
                    <select
                      className="form-select"
                      id="gender"
                      value={doctorDetails.gender}
                      onChange={(e) => rhandle(e)}
                      required
                    >
                      <option value="">Select Gender</option>
                      {gender.map((cat) => (
                        <option key={cat.id} value={cat.gender}>
                          {cat.gender}
                        </option>
                      ))}
                    </select>
                    </div>
                </div>
                </div>
                
                <div className="row">
                <div className="col-md-6">
                  <div className="form-floating-sm mb-2">
                    <label htmlFor="dob">DOB <span style={{color:"red"}}>* </span></label>
                    <input
                      className="form-control"
                      id="dob"
                      type="date"
                      placeholder="DOB"
                      value={doctorDetails.dob}
                      onChange={(e) => rhandle(e)}
                      required
                    />
                  </div>
                </div>
       
                <div className="col-md-6">
                  <div className="form-floating-sm mb-2">
                    <label htmlFor="pan">PAN <span style={{color:"red"}}>* </span></label>
                    <input
                      className="form-control"
                      id="pan"
                      type="text"
                      placeholder="PAN"
                      value={doctorDetails.pan}
                      onChange={(e) => rhandle(e)}
                      required
                    />
                    
                  </div>
                </div>
                </div>

                <div className="row">
                <div className="col-md-6">
                  <div className="form-floating-sm mb-2">
                    <label htmlFor="adharNumber">Aadhar Number <span style={{color:"red"}}>* </span></label>
                    <input
                      className="form-control"
                      id="adharNumber"
                      type="text"
                      placeholder="Aadhar Number"
                      value={doctorDetails.adharNumber}
                      onChange={(e) => rhandle(e)}
                      required
                    />
                  </div>
                </div>

                <div className="col-md-6">
    <div className="form-floating-sm mb-2">
      <label htmlFor="locationId">Location <span style={{color:"red"}}>* </span></label>
      <select
        className="form-select"
        id="locationId"
        value={doctorDetails.locationId || ""}
        onChange={(e) => rhandle(e)}
        required
      >
        {/* Default option to show "Select Location" */}
        <option value="" disabled>
          Select Location
        </option>
        {/* List all locations */}
        {locations.map((loc) => (
          <option key={loc.id} value={loc.id}>
            {loc.location}
          </option>
        ))}
      </select>
    </div>
  </div>
  </div>


  <div className="row">
  <div className="col-md-6">
                  <div className="form-floating-sm mb-2">
                    <label htmlFor="address">Address <span style={{color:"red"}}>* </span></label>
                    <textarea
                      className="form-control"
                      id="address"
                      type="text"
                      placeholder="Address"
                      value={doctorDetails.address}
                      onChange={(e) => rhandle(e)}
                      rows="2"
                      required
                    />
                 
                </div>
                </div>
                </div>

                <div className="row">
                <div className="col-md-4">
                  <div className="form-floating-sm mb-2">
                    <label htmlFor="city">City <span style={{color:"red"}}>* </span></label>
                    <input
                      className="form-control"
                      id="city"
                      type="text"
                      placeholder="City"
                      value={doctorDetails.city}
                      onChange={(e) => rhandle(e)}
                      required
                    />
                  </div>
                </div>

                <div className="col-md-4">
                  <div className="form-floating-sm mb-2">
                    <label htmlFor="pincode">Pincode <span style={{color:"red"}}>* </span></label>
                    <input
                      className="form-control"
                      id="pincode"
                      type="text"
                      placeholder="Pincode"
                      value={doctorDetails.pincode}
                      onChange={(e) => rhandle(e)}
                      required
                    />
                  </div>
                </div>

                <div className="col-md-4">
                  <div className="form-floating-sm mb-2">
                    <label htmlFor="state">State <span style={{color:"red"}}>* </span></label>
                    <input
                      className="form-control"
                      id="state"
                      type="text"
                      placeholder="State"
                      value={doctorDetails.state}
                      onChange={(e) => rhandle(e)}
                      required
                    />
                  </div>
                </div>
                </div>
        

                <div className="form-check mt-2 mb-2">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="sendNotification"
                    checked={doctorDetails.doctorDetails.sendNotification}
                    onChange={handleSendNotificationChange}
                  />
                  <label className="form-check-label" htmlFor="sendNotification">
                    Send Notification
                  </label>
                  </div>
                <br/>

                <input
                  type="submit"
                  value="SAVE"
                  className="btn btn-primary"
                  disabled={loading}

                />
                 &nbsp;&nbsp;&nbsp;&nbsp;

                <Button variant="secondary" onClick={onRequestClose}>
               Close
               </Button>  

              </form>
            </div>
          </div>
        </div>
              </Modal.Body>
      <Modal.Footer>
       </Modal.Footer>
    </Modal>
  );
}
export default AddDoctors;
